import React, { useEffect, useState } from 'react'

function FaqCategoryItem(props) {
  const { faqs = [], handleOnClick, activeTab, setActiveTab = false } = props

  const [activeClass, setActiveClass] = useState(null)

  useEffect(() => {
    if (window.location.pathname === '/faq') {
      setActiveClass('main')
    } else {
      setActiveClass('child')
    }
  }, [])

  const safeFaqs = Array.isArray(faqs) ? faqs : []

  if (safeFaqs.length === 0) return null

  if (setActiveTab) {
    return (
      <div className="FaqCategory__cardResult" id={activeClass}>
        {safeFaqs.map(faq => {
          if (faq.category && String(faq.category.id) === String(activeTab)) {
            return (
              <div
                key={faq.faqId}
                className="FaqCategory__cardResult__card"
                onClick={() => handleOnClick(faq)}
                onKeyDown={() => handleOnClick(faq)}
              >
                <div className="FaqCategory__cardResult__cardContent">
                  <div className="FaqCategory__cardResult__cardContent__title">
                    <p>{faq.category.text}</p>
                  </div>
                  <div className="FaqCategory__cardResult__cardContent__faqContent">
                    <h4>{faq.question}</h4>
                  </div>
                </div>
              </div>
            )
          }
          return null
        })}
      </div>
    )
  }
  return (
    <div className="FaqCategory__cardResult" id={activeClass}>
      {safeFaqs.map(faq => (
        <div
          key={faq.faqId}
          className="FaqCategory__cardResult__card"
          onClick={() => handleOnClick(faq)}
          onKeyDown={() => handleOnClick(faq)}
        >
          <div className="FaqCategory__cardResult__cardContent">
            <div className="FaqCategory__cardResult__cardContent__title">
              <p>{faq.category && faq.category.text}</p>
            </div>
            <div className="FaqCategory__cardResult__cardContent__faqContent">
              <h4>{faq.question}</h4>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default FaqCategoryItem
